import React from 'react';
import { FD130, FD132, FD133 } from '../../../services/pwd212Api';

interface Tab3Props {
  formData: Partial<FD130>;
  productDesc: Partial<FD132>;
  compositions: Partial<FD133>[];
  isEditing: boolean;
  isFieldDisabled: (key: string) => boolean;
  getField: (key: keyof FD130) => FD130[keyof FD130];
  setField: (key: keyof FD130, value: FD130[keyof FD130]) => void;
  getPDField: (key: keyof FD132) => FD132[keyof FD132];
  setPDField: (key: keyof FD132, value: FD132[keyof FD132]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
  names: Record<string, string>;
  setCompositions: React.Dispatch<React.SetStateAction<Partial<FD133>[]>>;
  addCompositionRow: () => void;
  deleteCompositionRow: (idx: number) => void;
}

const Tab3Material: React.FC<Tab3Props> = React.memo(({
  formData, productDesc, compositions, isEditing, isFieldDisabled,
  getField, setField, getPDField, setPDField, resolveSingleName, names,
  setCompositions, addCompositionRow, deleteCompositionRow,
}) => {
  const disabled = !isEditing;

  const handleCompChange = (idx: number, key: keyof FD133, value: FD133[keyof FD133]) => {
    setCompositions(prev => {
      const next = [...prev];
      next[idx] = { ...next[idx], [key]: value };
      return next;
    });
  };

  return (
    <>
      {/* Quality & Inspection */}
      <div className="form-section odd">
        <span className="section-tag">品質要求</span>
        <div className="form-grid">
          <label>品質要求代號</label>
          <div className="lookup-field">
            <input type="text" style={{ width: 120 }} maxLength={8}
              disabled={disabled}
              value={getPDField('fd132_38') as string}
              onChange={e => setPDField('fd132_38', e.target.value)}
              onBlur={() => resolveSingleName('qualityReq', 'qualityRequirement', getPDField('fd132_38') as string)}
            />
            <span className="lookup-name">{names.qualityReq || '--'}</span>
          </div>

          <label>品質要求說明</label>
          <div className="span-2">
            <textarea rows={2}
              disabled={disabled}
              value={getPDField('fd132_39') as string}
              onChange={e => setPDField('fd132_39', e.target.value)}
            />
          </div>

          <label>驗貨方式</label>
          <div className="lookup-field">
            <input type="text" style={{ width: 120 }} maxLength={8}
              disabled={disabled}
              value={getPDField('fd132_40') as string}
              onChange={e => setPDField('fd132_40', e.target.value)}
              onBlur={() => resolveSingleName('inspectionMethod', 'inspectionMethod', getPDField('fd132_40') as string)}
            />
            <span className="lookup-name">{names.inspectionMethod || '--'}</span>
          </div>
        </div>
      </div>

      {/* Composition Grid (FD133) */}
      <div className="form-section even">
        <span className="section-tag">原料組織比例</span>
        <div className="table-wrapper">
          <div className="table-toolbar">
            <div className="left">
              <span style={{ fontSize: 13 }}>組織比例明細 ({compositions.length} 項)</span>
              <span style={{ fontSize: 12, marginLeft: 12, color: 'var(--text-secondary)' }}>總項數: {formData.fd130_43 ?? 0}</span>
            </div>
            <div className="right">
              <button className="btn btn-sm" disabled={disabled || compositions.length >= 99} onClick={addCompositionRow}>新增</button>
            </div>
          </div>
          <div className="table-scroll">
            <table className="data-table">
              <thead>
                <tr>
                  <th style={{ width: 60 }}>項次</th>
                  <th className="num" style={{ width: 120 }}>組織比例%</th>
                  <th style={{ width: 60 }}>操作</th>
                </tr>
              </thead>
              <tbody>
                {compositions.length === 0 ? (
                  <tr><td colSpan={3} style={{ textAlign: 'center', color: 'var(--text-tertiary)' }}>無資料</td></tr>
                ) : compositions.map((c, i) => (
                  <tr key={i}>
                    <td>{c.fd133_02}</td>
                    <td className="num">
                      <input type="number" style={{ width: 100, textAlign: 'right' }} step="0.01"
                        disabled={disabled}
                        value={c.fd133_12 || ''}
                        onChange={e => handleCompChange(i, 'fd133_12', parseFloat(e.target.value) || 0)}
                      />
                    </td>
                    <td>
                      <button className="btn btn-sm btn-danger" disabled={disabled}
                        onClick={() => deleteCompositionRow(i)}
                      >
                        刪除
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Remarks */}
      <div className="form-section odd">
        <span className="section-tag">備註</span>
        <div className="form-grid">
          <label>備註代號</label>
          <div className="lookup-field">
            <input type="text" style={{ width: 80 }} maxLength={8}
              disabled={isFieldDisabled('fd130_411')}
              value={getField('fd130_411') as string}
              onChange={e => setField('fd130_411', e.target.value)}
              onBlur={() => resolveSingleName('remarkTemplate', 'remarkTemplate', getField('fd130_411') as string)}
            />
            <span className="lookup-name">{names.remarkTemplate || '--'}</span>
          </div>

          <label>備註內容</label>
          <div className="span-2">
            <textarea rows={3}
              disabled={isFieldDisabled('fd130_41')}
              value={getField('fd130_41') as string}
              onChange={e => setField('fd130_41', e.target.value)}
            />
          </div>
        </div>
      </div>
    </>
  );
});

Tab3Material.displayName = 'Tab3Material';
export default Tab3Material;
